import { intervalToDuration } from "date-fns";

import Icon from "@/components/Icon/Icon";
import { HStack, VStack } from "@/components/Layout";
import { useFormatDate, useFormatDuration } from "@/hooks/date";
import { defaultNS, useTranslation } from "@/lib/i18n";

type LastActivityCellProps = {
  date: Date | null;
  isActive?: boolean;
};

/** AppUserの最終利用日時を表示するセルコンポーネント */
export function LastActivityCell({
  date,
  isActive = false,
}: LastActivityCellProps) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "domain.appUser.component.LastActivityCell",
  });
  const formatDate = useFormatDate();
  const formatDuration = useFormatDuration();

  if (!date) {
    return <div className="text-sm">-</div>;
  }

  const duration = intervalToDuration({
    start: date,
    end: new Date(),
  });

  if (isActive) {
    return (
      <HStack className="items-center gap-2">
        <Icon iconName="HeartPulseIcon" />
        <div className="text-sm">
          {formatDate(date, { preset: "dateTime" })}
        </div>
      </HStack>
    );
  }

  return (
    <HStack className="items-center gap-2 text-sm text-destructive">
      <Icon iconName="MinusIcon" />
      <VStack>
        <span>{formatDate(date, { preset: "dateTime" })}</span>
        <span>
          {t("inactiveFor", {
            value: formatDuration(duration, {
              format: ["years", "months", "days"] as const,
            }),
          })}
        </span>
      </VStack>
    </HStack>
  );
}
